module.exports = __webpack_public_path__ + "img/ARENA2036_logo.f998e4c7.png";